const SOLICITATION_CONTACT_CONTROL_ITEMS = [
  { name: 'name', label: 'Nome e sobrenome' },
  { name: 'email', label: 'E-mail corporativo', type: 'email' },
  { name: 'phone', label: 'Telefone para contato' },
  { name: 'companyName', label: 'Nome da empresa' },
  { name: 'document', label: 'CPF ou CNPJ' },
]

const EMPLOYEES_OPTIONS = [
  'Não tenho funcionário',
  'De 1 a 15',
  'De 16 a 50',
  'Acima de 50',
]

const SEGMENT_OPTIONS = [
  'CEO / Proprietário(a)',
  'Gerente / Liderança de Tecnologia e Infraestrutura',
  'Analista de Tecnologia e Infraestrutura',
  'Liderança de Segurança da Informação',
  'Analista de Segurança da Informação',
  'Jurídico',
  'Liderança de Financeiro e RH',
  'Analista de Negócios de Vendas',
  'Analista de Financeiro e RH',
  'Liderança de Marketing',
  'Analista de Marketing',
  'Encarregado de Proteção de Dados(DPO) da empresa',
  'Outros',
]

export default {
  SOLICITATION_CONTACT_CONTROL_ITEMS,
  SEGMENT_OPTIONS,
  EMPLOYEES_OPTIONS,
}
